module.exports = __webpack_public_path__ + "/images/logo-fr-autour-bebe.9192e91.png";